<template>
    <div class="form-component">
        <v-form ref="form" v-model="valid">
            <h3 class="form-title">
                <v-btn fab color="primary" @click="goTo('/MailConfigurationlist')">
                    <v-icon large>arrow_left</v-icon>
                </v-btn>
                {{ title }} Configuración IMAP
            </h3>
            <v-container fluid class="pa-0">
                <v-layout row wrap>
                    <v-flex xs12 md4>
                        <v-text-field class="lance"
                            label="Código"
                            v-model="form.code"
                            :rules="[v => !!v || 'Campo requerido']"
                            :disabled="view">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12 md4>
                        <v-text-field class="lance"
                            label="Nombre"
                            v-model="form.name"
                            :rules="[v => !!v || 'Campo requerido']"
                            :disabled="view">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12 md4>
                        <v-text-field class="lance"
                            label="Descripción"
                            v-model="form.description"
                            :disabled="view">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12 class="divider"></v-flex>
                    <v-flex xs12 md4>
                        <v-text-field class="lance"
                            label="Servidor"
                            v-model="form.server"
                            :rules="[v => !!v || 'Campo requerido']"
                            :disabled="view">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12 md4>
                        <v-text-field class="lance"
                            label="Puerto"
                            type="number"
                            v-model="form.port"
                            :rules="[v => !!v || 'Campo requerido']"
                            :disabled="view">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12 md4 class="text-xs-center">
                        <span class="mr-4">Usar TLS (Mail Seguro)</span>
                        <v-switch
                            style="display: inline-block;"
                            color="primary"
                            v-model="form.useTLS"
                            :disabled="view">
                        >
                        </v-switch>
                    </v-flex>

                    <v-flex xs12 md4>
                        <v-text-field class="lance"
                            label="Usuario"
                            v-model="form.username"
                            :rules="[v => !!v || 'Campo requerido']"
                            :disabled="view">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12 md4>
                        <v-text-field class="lance"
                            v-if="!view"
                            label="Contraseña"
                            type="password"
                            v-model="form.password"
                            :rules="[v => !!v || 'Campo requerido']"
                            :disabled="view">
                        </v-text-field>
                    </v-flex>
                </v-layout>

                <v-layout row wrap>
                    <v-flex xs12 md4>
                        <v-btn v-if="!view"
                            solo
                            color="primary"
                            @click="test()"
                            :loading="testing"
                            :disabled="!valid || testing">Prueba</v-btn>
                    </v-flex>
                    <v-flex xs12 md4>
                        <v-btn v-if="!view"
                            solo
                            color="submitBtn"
                            @click="save()"
                            :disabled="!valid || sending">Guardar</v-btn>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-form>
    </div>
</template>


<script>
    import { events } from '../main';
    import { _ } from 'underscore';
    import moment from 'moment-timezone';
    import Swatches from 'vue-swatches'
    import IconPicker from './modals/icon-picker'
    import ImagePicker from './imagePicker';
    import ColorPicker from './colorPicker';
    import VueGridLayout from 'vue-grid-layout';

    export default {
        name: 'MailConfigurationform',
        components: {
            Swatches,
            IconPicker,
            ImagePicker,
            ColorPicker,
        },
        data() {
            return {
                title: 'Nueva',
                valid: true,
                sending: false,
                testing: false,
                view: false,
                id: '',
                form: {
                },
                credentials: JSON.parse(localStorage.getItem('userCredentials')),
            }
        },
        methods: {
            snackbar(message) {
                events.$emit('snackbar', message);            
            },
            goTo(url) {
                this.$router.push(url);
            },
            dataInit() {
                var self = this;
                if (this.id) {
                    this.getRegistry(this.id);
                } else {
                    this.$http.get('MailConfiguration/form')
                    .then(response => {
                        var newform = response.body.MailConfiguration;
                        this.form = newform;
                    });
                }
            },
            getRegistry(id) {
                var self = this;
                this.$http.get('MailConfiguration/form/' + this.id)
                .then(response => {
                    self.form = response.body.MailConfiguration;
                    
                }, error => {
                    self.snackbar('Error al obtener registro');
                    this.goBack();
                });
            },
            save() {
                if (this.$refs.form.validate()) {
                    this.sending = true;
                    this.form.updatedById = localStorage.getItem('userId');
                    if (this.id) {
                        this.$http.put('MailConfiguration/' + this.id, this.form)
                            .then(response => {
                                this.snackbar('Registro actualizado con éxito');
                                this.$router.push('/MailConfigurationlist');                              
                            }, error => {
                                this.sending = false;                                
                                this.snackbar(error.body.msg || 'Error al actualizar registro');
                        });
                    } else {
                        this.form.createdById = localStorage.getItem('userId');
                        this.$http.post('MailConfiguration/', this.form)
                            .then(response => {
                                this.snackbar('Registro creado con éxito');
                                this.$router.push('/MailConfigurationlist');   
                            }, error => {
                                this.sending = false;
                                this.snackbar(error.body.msg || 'Error al crear registro');
                        });
                    }
                }
            },
            test() {
                if (this.$refs.form.validate()) {
                    this.testing = true;
                    this.$http.post('MailConfiguration/test', this.form).then(
                        response => {
                            this.snackbar(response.body ? "Prueba exitosa": "Prueba fallida");
                        },
                        error => {
                            this.snackbar(error.body.msg || "Hubo un error al hacer la prueba");
                        }
                    ).finally(() => this.testing = false);
                }
            },
            gridItem(id) {
                return this.layout.filter(x => x.i === id)[0];
            },
        },
        mounted() {
            this.id = this.$route.params.id;
            if (this.$route.name.includes('detail') ) {
                this.view = true;
                this.title = "Detalle de";
            } else if (this.$route.name.includes('edit')) {
                this.view = false;
                this.title = "Editar";
            }
            this.dataInit();
        }
    }
</script>